module.exports = __webpack_public_path__ + "media/images/logo-full-white-87bc69ee7cabe99c7e0197cff70e1c7d.png";